import { Loader } from './loader';
import { normalizeUrl } from './normalize-url';
import * as loaderFactory from '../index';

let loaders: { [name: string]: Loader } = {};
let defaultLoader: Loader;

export function getLoader(registryUrl?: string, namespace?: string): Loader {
  if (!registryUrl) {
    if (!defaultLoader) {
      throw new Error(
        'Default Loader not created. Call "getLoader" with "registryUrl" param to create and use default loader'
      );
    } else {
      return defaultLoader;
    }
  }

  const loaderKey = normalizeUrl(registryUrl) + namespace;
  let loader: Loader;
  if (!Object.prototype.hasOwnProperty.call(loaders, loaderKey)) {
    loaders[loaderKey] = loader = new Loader(registryUrl);
    loader.register('@ipreo/nmp-loader', loaderFactory);
  }
  if (!defaultLoader) {
    defaultLoader = loaders[loaderKey];
  }

  return loaders[loaderKey];
}

export function clearLoaders(): void {
  loaders = {};
}
